import React, { useState } from 'react';
import { Checkbox, Button, Collapse } from 'antd';
import "./sync.css";
import { Header } from 'antd/es/layout/layout';
import { syncData } from '../../services/api';


const Sync = ({ selectedDatabase }) => {
  const [selectedYears, setSelectedYears] = useState([]);
  const years = Array.from({length: 24}, (_, i) => 2000 + i);

  const handleYearChange = (year) => {
    setSelectedYears(prev => 
      prev.includes(year) ? prev.filter(y => y !== year) : [...prev, year]
    );
  };

  const handleSync = () => {
    syncData(selectedYears, selectedDatabase)
  }

  const groupedYears = years.reduce((groups, year) => {
    const decade = Math.floor(year / 10) * 10;
    if (!groups[decade]) groups[decade] = [];
    groups[decade].push(year);
    return groups;
  }, {});

  return (
    <div className="center-box">
    <Header className="header">Sync data by year:</Header>        
      <Collapse accordion>
        {Object.entries(groupedYears).map(([decade, years]) => (
          <Collapse.Panel header={decade} key={decade}>
            {years.map(year => (
              <Checkbox 
                key={year}
                onChange={() => handleYearChange(year)}
                checked={selectedYears.includes(year)}
              >
                {year}
              </Checkbox>
            ))}
          </Collapse.Panel>
        ))}
      </Collapse>
      <Button type="primary" onClick={handleSync} style={{ marginTop: '10px' }}>Sync</Button>
    </div>
  );
};

export default Sync;